import Validator from 'validatorjs';
import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';

import { FormControl } from '../../../../../facturotopia';
import CartaPorteClaveUnidadPesoSuggestions from './suggestions/CartaPorteClaveUnidadPesoSuggestions';

class CartaPorteMercanciaDetalleMercanciaForm extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      isValid: false,
      validator: new Validator({}, this.rules({}))
    };
  }

  rules(data) {
    const isTouched = this.isTouched(data);

    const UnidadPesoMerc = ['string'];
    const PesoBruto = ['decimal:3', 'min:0.001'];
    const PesoNeto = ['decimal:3', 'min:0.001'];
    const PesoTara = ['decimal:3', 'min:0.001'];
    const NumPiezas = ['integer', 'min:1'];

    return {
      'UnidadPesoMerc': isTouched ? ['required'].concat(UnidadPesoMerc) : UnidadPesoMerc,
      'PesoBruto': isTouched ? ['required'].concat(PesoBruto) : PesoBruto,
      'PesoNeto': isTouched ? ['required'].concat(PesoNeto) : PesoNeto,
      'PesoTara': isTouched ? ['required'].concat(PesoTara) : PesoTara,
      'NumPiezas': isTouched ? NumPiezas : NumPiezas,
    }
  }

  isTouched = (values = {}) => {
    const props = [
      'UnidadPesoMerc',
      'PesoBruto',
      'PesoNeto',
      'PesoTara',
      'NumPiezas',
    ];

    let touched = false;

    for (const prop of props) {
      if (values[prop] !== undefined && values[prop] !== '') {
        touched = true;
        break;
      }
    }

    return touched;
  }

  handleOnChange = (value) => {
    const data = {
      ...this.props.data,
      ...value
    }

    this.notifyFormDataChange(data);
  }

  notifyFormDataChange = (data) => {
    const validator = this.validate(data);

    this.setState({
      isValid: validator.passes(),
    });

    this.props.onFormDataChange({
      data,
      isValid: validator.passes(),
      isTouched: true
    });
  }

  validate(data) {
    const validator = new Validator(data, this.rules(data));

    validator.check();

    this.setState({
      validator
    });

    return validator;
  }

  handleOnSuggestionSelect = (name) => (item) => {
    const value = item ? item.clave : '';

    let values = {
      [name]: value
    };

    this.handleOnChange(values);
  }

  render() {
    const { data } = this.props;
    const rules = this.rules(data);

    return (
      <>
        <div>
          <strong>Detalle Mercancia</strong>
        </div>

        <Row>
          <Col sm md={ 4 }>
            <CartaPorteClaveUnidadPesoSuggestions
              label="Unidad Peso Mercancía"
              name="UnidadPesoMerc"
              rules={ rules.UnidadPesoMerc }
              value={ data.UnidadPesoMerc }
              onSelect={ this.handleOnSuggestionSelect('UnidadPesoMerc') }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="number"
              label="Peso Bruto"
              name="PesoBruto"
              placeholder=""
              help=""
              minLength="16"
              maxLength="36"
              rules={ rules.PesoBruto }
              value={ data.PesoBruto }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="number"
              label="Peso Neto"
              name="PesoNeto"
              placeholder=""
              help=""
              minLength="16"
              maxLength="36"
              rules={ rules.PesoNeto }
              value={ data.PesoNeto }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="number"
              label="Peso Tara"
              name="PesoTara"
              placeholder=""
              help=""
              minLength="16"
              maxLength="36"
              rules={ rules.PesoTara }
              value={ data.PesoTara }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="number"
              label="Número de Piezas"
              name="NumPiezas"
              placeholder=""
              help=""
              minLength="16"
              maxLength="36"
              rules={ rules.NumPiezas }
              value={ data.NumPiezas }
              onChange={ this.handleOnChange }
            />
          </Col>
        </Row>
      </>
    )
  }
}

export default CartaPorteMercanciaDetalleMercanciaForm;